const MD_BREAKPOINT = 744;

export default function initStep() {
  const stepTiles = document.querySelectorAll(".step-tile");

  if (!stepTiles.length) return;

  const mediaQuery = window.matchMedia(`(max-width: ${MD_BREAKPOINT - 1}px)`);

  stepTiles.forEach((tile) => {
    const toggler = tile.querySelector(".step-toggler");
    const content = tile.querySelector(".step-tile-content");

    if (!toggler || !content) return;

    // Toggle expand/collapse on click
    function handleClick() {
      if (!mediaQuery.matches) return;

      const isOpen = tile.classList.contains("is-open");

      if (isOpen) {
        // Closing: set current height first, then animate to 0
        content.style.maxHeight = content.scrollHeight + "px";
        // Force reflow
        content.offsetHeight;
        content.style.maxHeight = "0";
        tile.classList.remove("is-open");
      } else {
        // Opening: lock starting point first, then animate to scrollHeight
        // This prevents CSS max-height:none from causing instant jump
        content.style.maxHeight = "0";
        // Force reflow
        content.offsetHeight;
        // Add class for other styles (opacity, margin)
        tile.classList.add("is-open");
        // Animate to target height
        content.style.maxHeight = content.scrollHeight + "px";

        // After transition, set to none to allow dynamic content
        content.addEventListener(
          "transitionend",
          () => {
            if (tile.classList.contains("is-open")) {
              content.style.maxHeight = "none";
            }
          },
          { once: true }
        );
      }
    }

    // Click on toggler
    toggler.addEventListener("click", handleClick);

    // Also allow clicking on the title area to toggle
    const titleArea = tile.querySelector(".step-tile-title");
    if (titleArea) {
      titleArea.style.cursor = "pointer";
      titleArea.addEventListener("click", () => {
        if (mediaQuery.matches) {
          handleClick();
        }
      });
    }

    // Reset state when switching to desktop
    mediaQuery.addEventListener("change", (e) => {
      if (!e.matches) {
        // Switched to desktop - remove open state and inline styles
        tile.classList.remove("is-open");
        content.style.maxHeight = "";
      } else {
        // Switched to mobile - if already has is-open, expand it
        if (tile.classList.contains("is-open")) {
          content.style.maxHeight = "none";
        }
      }
    });

    // Initialize: if already has is-open class on mobile, expand it
    if (mediaQuery.matches && tile.classList.contains("is-open")) {
      content.style.maxHeight = "none";
    }
  });
}
